// Libs
import { DateTime } from 'luxon'

/**
 * @typedef Option
 * @type {Object}
 * @property {String} label: Type name
 * @property {String} value: Type value
 */

export class SubsReportCommon {

  /** @type {Array<Option>} */
  static dateType = [
    {
      label: 'ทั้งหมด',
      value: null
    },
    {
      label: 'วันชำระ',
      value: 'RCPT_PAID'
    },
    {
      label: 'วันนัด',
      value: 'APPT_DATE'
    },
    {
      label: 'ใช้เมื่อ',
      value: 'APPT_USED'
    },
    {
      label: 'วันที่ใบเสร็จ',
      value: 'APPT_RECEIPTED'
    },
    {
      label: 'วันปิดงาน',
      value: 'APPT_FULFILLED'
    },
    {
      label: 'วันสิ้นสุด',
      value: 'SUBS_EXPIRED'
    },
  ]

  /** @type {Array<Option>} */
  static status = [
    {
      label: 'ทั้งหมด',
      value: null
    },
    {
      label: 'Subscribed',
      value: 'SUBS_SUBSCRIBED'
    },
    {
      label: 'Cancelled',
      value: 'SUBS_CANCELLED'
    },
    {
      label: 'Unsubscribed',
      value: 'SUBS_UNSUBSCRIBED'
    },
    {
      label: 'Expired',
      value: 'SUBS_EXPIRED'
    },
  ]

  /** @type {Array<Option>} */
  static pkg = [
    {
      label: 'ทั้งหมด',
      value: null
    },
    {
      label: 'Free Trial',
      value: 'PKG_FREETRIAL'
    },
    {
      label: 'One-time',
      value: 'PKG_ONETIME'
    },
    {
      label: 'Subscribe',
      value: 'PKG_SUBSCRIBE'
    },
  ]

  /** @type {Array<Option>} */
  static receipt = [
    {
      label: 'ทั้งหมด',
      value: null
    },
    {
      label: 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
      value: 'RECEIPT'
    },
    {
      label: 'ใบกำกับภาษี',
      value: 'TAX'
    },
    {
      label: 'ใบลดหนี้',
      value: 'CREDIT'
    },
  ]

  /** @type {Array<Option>} */
  static seller = [
    {
      label: 'ทั้งหมด',
      value: null
    },
    {
      label: 'SC Asset',
      value: 'SC_ASSET'
    },
    {
      label: 'SC Able',
      value: 'SC_ABLE',
    },
  ]

  /** @type {Array<Option>} */
  static groupName = [
    {
      label: 'ทั้งหมด',
      value: null
    },
    {
      label: 'Home Expert',
      value: 'Home Expert'
    },
    {
      label: 'Life Style',
      value: 'Life Style'
    },
    {
      label: 'Subscription',
      value: 'Subscription'
    },
    {
      label: 'Ruejai Club',
      value: 'Ruejai Club'
    },
    {
      label: 'RJB2B',
      value: 'RJB2B'
    },
  ]

  static formatDate(date) {

    // Validate date
    if (!date) return null

    // Date format
    const format = 'yyyy/MM/dd'

    return (
      DateTime.fromJSDate(new Date(date)).toFormat(format)
    )
  }
}